<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5TOKch/tc-custom/9781429968386.jpg?1733043180922" alt="This image is the cover for the book City of Dragons, The Miranda Corbie Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">City of Dragons, The Miranda Corbie Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>February, 1940. In San Francisco's Chinatown, fireworks explode as the city celebrates Chinese New Year with a Rice Bowl Party, a three day-and-night carnival designed to raise money and support for China war relief. Miranda Corbie is a 33-year-old private investigator who stumbles upon the fatally shot body of Eddie Takahashi. The Chamber of Commerce wants it covered up. The cops acquiesce. All Miranda wants is justice--whatever it costs. From Chinatown tenements, to a tattered tailor's shop in Little Osaka, to a high-class bordello draped in Southern Gothic, she shakes down the city--her city--seeking the truth. An outstanding series debut.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelli Stanley
      </h2>
      
      <p class="authorDescription body article"><P>KELLI STANLEY's first novel in the 1940 San Francisco-set Miranda Corbie series, CITY OF DRAGONS, was met with overwhelming critical acclaim and was a finalist for the prestigious Los Angeles Times Book Prize. Stanley also writes a highly-praised series set in Roman Britain, the latest of which is THE CURSE-MAKER. Her debut novel, NOX DORMIENDA, won the Bruce Alexander Award for best historical mystery of 2008. She makes her home in Dashiell Hammett's San Francisco, earned a Master's Degree in Classics, and loves jazz, old movies, fedoras, Art Deco and speakeasies.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Minotaur Books A Thomas Dunne Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c56d67a